import { API_DOMAIN } from '@constants';
import type { LibItemArticle } from '@types';
import axios from '@utils/axios';

type AItem = Pick<LibItemArticle, 'id' | 'title' | 'thumb' | 'text'>;

function fetchArticleItem(id: number) {
  return axios.get<AItem>(`${API_DOMAIN}/articles/${id}`);
}

export default fetchArticleItem;
